export enum Interest {
    NON_COMMERCIAL = 'non commercial transactions',
    COMMERCIAL = 'commercial transactions',
    LAMF = 'lamf',
    ECAS = 'e-cas',
}